export var ASC = 'ASC';
export var DESC = 'DESC';
export var SMALL = 'small';
export var LARGE = 'large';
export var LOADING_CONTENTS_OPACITY = 0.22;